import angular from 'angular'

import { assign } from 'lodash-es'

import debugFields from './debug-fields'

angular
  .module('ggs.utils')
  .factory('Retry', RetryProvider)

function RetryProvider($q, qh) {
  return function Retry(retryDelay, retryLimit, action, onError) {
    const qAction = qh.wrap(action)
    const qOnError = qh.wrap(onError)

    function retry_wrapper() {
      let tryCount = 0
      const errors = assign([], { retryErrors: true })
      const args = arguments
      return tryCall()

      function tryCall() {
        tryCount++
        return qAction.apply(null, args).catch(onCallFail)
      }

      function onCallFail(err) {
        errors.push(err)
        const willRetry = tryCount < retryLimit
        const retryDesc = willRetry
          ? `attempt ${tryCount}/${retryLimit} is failed! next attempt in ${retryDelay}ms!`
          : `attempt ${tryCount}/${retryLimit} is failed! it was the last attempt!`
        return qOnError(err, retryDesc, willRetry).then(() => {
          return willRetry
            ? qh.delay(retryDelay).then(tryCall)
            : $q.reject(errors)
        })
      }
    }

    return debugFields(retry_wrapper, {
      _action: action,
      _onError: onError,
      _retryDelay: retryDelay,
      _retryLimit: retryLimit
    })
  }
}
